import { Pic } from "./Pic";

import { ArrowUpRight, FileText } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "./Motion";
import { useT } from "@/i18n";

const THUMBS = ["errore-umidita.jpg", "errore-impianti.jpg", "errore-ponti-termici.jpg", "errore-logistica.jpg"];

export const GuideTeaser = () => {
  const t = useT();
  return (
    <section className="bg-[#EFECE6] px-5 py-20 text-[#121110] sm:px-8 lg:py-28" data-testid="guide-teaser">
      <Reveal className="mx-auto grid max-w-[1500px] gap-10 border-y-2 border-[#121110] py-12 lg:grid-cols-12 lg:items-center">
        <div className="lg:col-span-6">
          <p className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-[#C26D38]"><FileText className="h-4 w-4" /> {t("guide.label", "Guida tecnica")}</p>
          <h2 className="mt-5 font-display text-3xl font-bold leading-tight tracking-tight sm:text-5xl">
            {t("guide.h1", "4 errori fatali")} {t("guide.h2a", "da evitare nelle")} <em className="font-serif font-normal text-[#C26D38]">{t("guide.h2em", "case in legno.")}</em>
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-[#6E685E] sm:text-lg">{t("guide.teaser2", "Umidità di risalita, impianti, ponti termici e logistica: cosa può compromettere una casa in legno e come evitarlo. In più, la guida per scegliere tra X-LAM e telaio. Leggile online o scaricale in PDF.")}</p>
          <Link to="/guida-tecnica" className="btn-amber mt-8" data-testid="guide-teaser-link">{t("guide.read", "Leggi la guida")} <ArrowUpRight className="h-4 w-4" /></Link>
        </div>
        <Link to="/guida-tecnica" className="group grid grid-cols-2 gap-3 lg:col-span-5 lg:col-start-8" aria-label={t("guide.read", "Leggi la guida")} data-testid="guide-teaser-thumbs">
          {THUMBS.map((src, i) => (
            <div key={src} className="relative aspect-[5/4] overflow-hidden bg-[#1E1C1A]">
              <Pic src={`/img/emma/${src}`} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <span className="absolute left-2 top-2 rounded-full bg-[#121110]/80 px-2.5 py-1 font-mono text-xs text-[#F7F5F0]">0{i + 1}</span>
            </div>
          ))}
        </Link>
      </Reveal>
    </section>
  );
};
